
/**
 * This is how I make the table of spell slots for
 * the various magical classes/subclasses.
 * 
 */

export class TableEntry {
  level = 1;
  data: { [key: string]: number } = {};
  
  constructor(obj?: any) {
    this.level = obj ? obj.level : 1;
    this.data = obj ? obj.data : {};
    if (this.data[""] !== undefined) {
      delete (this.data as any)[""];
    }
  }

  toDBObj(): any {
    return {
      level: this.level,
      data: this.data,
    };
  }

  copy(copyMe: TableEntry): void {
    this.level = copyMe.level;
    this.data = {...copyMe.data};
  }

  clone(): TableEntry {
    const new_obj = new TableEntry();
    new_obj.copy(this);
    return new_obj;
  }
}